import React, { useCallback } from 'react';
import { useFormState } from 'react-final-form';
import { useHistory } from 'react-router';
import last from 'lodash/last';

import PageUrls from 'Shared/constants/PageUrls.constants';

import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';

import { Steps } from '../types';

type Props = {
  step: Steps;
  errorsDisableSubmit?: Function;
  onBack?: Function;
  onCancel?: Function;
};

export default function NewGoalButtonsArea({ step, errorsDisableSubmit, onBack, onCancel }: Props) {
  const history = useHistory();
  const isLastStep = last(Object.values(Steps)) === step;
  const showBackButton = !!isLastStep;

  const handleCancelClick = useCallback(() => {
    if (onCancel) {
      onCancel();
    } else {
      if (history.length > 0) history.goBack();
      else history.push(PageUrls.HOME_PAGE);
    }
  }, [history, onCancel]);

  const handleBackButtonClick = useCallback(() => onBack(), [onBack]);

  const { submitting, errors } = useFormState();
  const errorsExist = errorsDisableSubmit
    ? errorsDisableSubmit(errors)
    : !!Object.keys(errors).filter(key => errors[key]).length;

  return (
    <div className="d-flex justify-content-between w-100 mt-5">
      {showBackButton && (
        <WpButton variant="tertiary" onClick={handleBackButtonClick}>
          <WpIcon name="chevron-left" />
          Back
        </WpButton>
      )}
      <div className="d-flex justify-content-end w-100">
        <WpButtonGroup>
          <WpButton variant="tertiary" onClick={handleCancelClick}>
            Cancel
          </WpButton>
          <WpButton
            size="md"
            btnType="submit"
            disabled={errorsExist}
            loading={submitting}
            qaTest="btn-create-goal-submit-form"
          >
            {isLastStep ? 'Create Goal' : 'Next'}
          </WpButton>
        </WpButtonGroup>
      </div>
    </div>
  );
}
